import React, { FC } from "react";
import PropTypes from "prop-types";

import CloseBtn from "../assets/close_btn.png";
import { useGlobalContext } from "./ScanViewerContext";

import styles from "./closeButton.module.scss";

type Props = {
  onCloseBtn: () => void;
  closeButton?: React.ReactNode;
};

const CloseButton: FC<Props> = ({ onCloseBtn, closeButton }) => {
  const { isMobileOnLandscape } = useGlobalContext();
  return closeButton != null ? (
    <div
      data-cy="closeBtn"
      onClick={onCloseBtn}
      className={` ${styles.closeBtn} ${
        isMobileOnLandscape && styles.closeBtnLandscape
      }`}
    >
      {closeButton}
    </div>
  ) : (
    <span
      data-cy="closeBtn"
      onClick={onCloseBtn}
      className={` ${styles.closeBtn} ${
        isMobileOnLandscape && styles.closeBtnLandscape
      }`}
    >
      <img src={CloseBtn} alt="" style={{ height: "28px", width: "28px" }} />
    </span>
  );
};

CloseButton.propTypes = {
  onCloseBtn: PropTypes.func.isRequired,
  closeButton: PropTypes.bool,
};

export default CloseButton;
